export const environment = {
  stage: 'dev',
  apiBaseUrl: 'https://api.meenasilver.com/api/',  // Updated backend URL
  appName: 'Meena Silver',
};

//host url= http://52.66.253.214/api/'